"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectOffersAccordionBoxContent = function SelectOffersAccordionBoxContent(_ref) {
  var children = _ref.children,
      open = _ref.open;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    open: open
  }, children);
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["display:", ";"], function (_ref2) {
  var open = _ref2.open;
  return open ? 'block' : 'none';
});

SelectOffersAccordionBoxContent.propTypes = {
  children: _propTypes.node,
  open: _propTypes.bool
};
var _default = SelectOffersAccordionBoxContent;
exports.default = _default;